"use client";
import React, { useEffect, useRef, useState } from "react";
import logo1 from "./logo1.jpg";
import search from "./searchmobile.png";
import logo2 from "./logo2.png";
import searchSmall from "./search-lg.jpg";
import {
  Container,
  Dropdown1,
  Dropdown2,
  Summary,
  P,
  Link,
  Link1,
  Logo,
  Div,
  HeaderContainer,
  PContainer,
  Question,
  InnerSearchContainer,
  SearchBar,
  SearchBarContainer,
  SearchImg,
  SearchText,
  SearchContainer,
  AllResults,
  Result,
  XSearch,
  PContainer1,
  DivLink,
  Link2,
  Burger,
  InnerSearchContainerSmall,
  LogoSmall,
  SearchSmall,
  SmallHeaderContainer,
  SmallHeaderQuestion2,
  SmallHeaderBigs,
  SmallHeaderConsult,
  SmallHeaderLink,
  SmallHeaderQuestion,
  Links,
  LinksContainer,
} from "./styles";
import { useNavigation } from "../../../types/Navigates";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const searchRef = useRef(null);
  const searchRefSmall = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");

  const data = [
    {
      adress: "/",
      title: "ГЛАВНАЯ",
    },
    {
      adress: "/policy",
      title: "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ",
    },
    {
      adress: "/about/blog",
      title: "БЛОГ",
    },
    {
      adress: "/ratings",
      title: "ОТЗЫВЫ",
    },
    {
      adress: "/about/company",
      title: "О КОМПАНИИ",
    },
    {
      adress: "/services",
      title: "УСЛУГИ",
    },

    {
      adress: "/services/talkitout",
      title: "ВЫГОВОРИТЬСЯ",
    },
    {
      adress: "/services/careerconsulting",
      title: "КАРЬЕРНАЯ КОНСУЛЬТАЦИЯ",
    },
    {
      adress: "/services/vs",
      title: "Ведение вакансий",
    },
    {
      adress: "/services/supportduringthejobsearchsupport",
      title: "СОПРОВОЖДЕНИЕ ПОИСКА РАБОТЫ",
    },
    {
      adress: "/services/supportduringtheprobationaryperiod",
      title: "СОПРОВОЖДЕНИЕ ИСПЫТАТЕЛЬНОГО СРОКА",
    },
    {
      adress: "/services/recruitmentofITspecialists",
      title: "ПОДБОР IT СПЕЦИАЛИСТОВ",
    },
    {
      adress: "/services/trainingofITrecruiters",
      title: "ОБУЧЕНИЕ ПРОФЕССИИ IT РЕКРУТЕР",
    },
    {
      adress: "/services/cvready",
      title: "РЕЗЮМЕ «ПОД КЛЮЧ»",
    },
  ];

  const { toServices6, toServices7, toMain } = useNavigation();

  const ShowSearchSmall = () => {
    if (searchRefSmall.current) {
      searchRefSmall.current.style.display = "block";
    }
  };
  const ShowSearch = () => {
    if (searchRef.current) {
      searchRef.current.style.display = "block";
    }
  };
  const HideSearch = () => {
    if (searchRef.current) {
      searchRef.current.style.display = "none";
    }
  };
  const HideSearchSmall = () => {
    if (searchRefSmall.current) {
      searchRefSmall.current.style.display = "none";
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Фильтрация данных на основе поискового запроса
  const filteredData = data.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpenSmall, setIsOpenSmall] = useState(false);

  const handleToggle1 = () => {
    return setIsOpen1((prev) => !prev);
  };
  const handleToggle2 = () => {
    return setIsOpen2((prev) => !prev);
  };

  const navigate = useNavigate();
  const contR = useRef<HTMLDivElement | null>(null);
  const PcontR = useRef<HTMLDivElement | null>(null);

  const toBlog = () => {
    if (contR.current) {
      contR.current.style.display = "none";
      navigate("/about/blog");
    }
  };
  const toRatings = () => {
    if (contR.current) {
      contR.current.style.display = "none";
      navigate("/ratings");
    }
  };
  const toAbout = () => {
    if (contR.current) {
      contR.current.style.display = "none";
      navigate("/about/company");
    }
  };
  const toServices1 = () => {
    if (PcontR.current) {
      PcontR.current.style.display = "none";
      navigate("/services/talkitout");
    }
  };
  const toServices2 = () => {
    if (PcontR.current) {
      PcontR.current.style.display = "none";
      navigate("/services/careerconsulting");
    }
  };
  const toServices3 = () => {
    if (PcontR.current) {
      PcontR.current.style.display = "none";
      navigate("/services/cvready");
    }
  };
  const toServices4 = () => {
    if (PcontR.current) {
      PcontR.current.style.display = "none";
      navigate("/services/supportduringthejobsearchsupport");
    }
  };
  const toServices5 = () => {
    if (PcontR.current) {
      PcontR.current.style.display = "none";
      navigate("/services/supportduringtheprobationaryperiod");
    }
  };
  return (
    <HeaderContainer>
      <SearchContainer ref={searchRef}>
        <InnerSearchContainer>
          <XSearch $img={require("./x.png")} onClick={HideSearch} />
          <SearchText>Поиск</SearchText>
          <SearchBarContainer>
            <SearchBar
              type="text"
              placeholder="Введите запрос"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <SearchImg src={search} />
          </SearchBarContainer>
          {filteredData.length > 0 && (
            <AllResults>
              {filteredData.map((item, index) => (
                <Result key={index} href={item.adress}>
                  {item.title.toLowerCase()}
                </Result>
              ))}
            </AllResults>
          )}
        </InnerSearchContainer>
      </SearchContainer>
      <SearchContainer ref={searchRefSmall}>
        <InnerSearchContainerSmall>
          <SearchSmall src={searchSmall} onClick={ShowSearch} />
          <XSearch $img={require("./x.png")} onClick={HideSearchSmall} />
          <LogoSmall src={logo2} onClick={toMain} />
          <SmallHeaderContainer>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <SmallHeaderConsult>Консалтинг</SmallHeaderConsult>
            <br />
            <SmallHeaderLink href="/services/supportduringthejobsearchsupport">
              Сопровождение
            </SmallHeaderLink>
            <SmallHeaderLink href="/services/supportduringtheprobationaryperiod">
              Сопровождение испытательного срока
            </SmallHeaderLink>
            <SmallHeaderLink href="/services/cvready">
              Резюме «Под ключ»
            </SmallHeaderLink>
            <SmallHeaderLink href="/services/vs">
              Месячная подписка на поиск вакансий
            </SmallHeaderLink>
            <SmallHeaderLink href="/services/careerconsulting">
              Карьерная консультация
            </SmallHeaderLink>
            <SmallHeaderLink href="/services/talkitout">
              Карьерная сессия «Выговориться»
            </SmallHeaderLink>
            <br />
            <br />
            <br />
            <SmallHeaderBigs href="/about/company">О нас</SmallHeaderBigs>
            <SmallHeaderBigs href="/ratings">Отзывы</SmallHeaderBigs>
            <SmallHeaderBigs href="/about/blog">Блог</SmallHeaderBigs>
            <SmallHeaderQuestion href="https://t.me/ProhorovaConsult">
              Задать вопрос
            </SmallHeaderQuestion>
            <SmallHeaderQuestion2 href="https://t.me/belaymamba_vacancy">
              Чат с вакансиями в Telegram
            </SmallHeaderQuestion2>
            <LinksContainer>
              <Links href="https://t.me/ProhorovaConsult">LinkedIn / </Links>
              <Links>Telegram / </Links>
              <Links href="https://t.me/ProhorovaConsult">Instagram / </Links>
              <Links>YouTube</Links>
            </LinksContainer>
          </SmallHeaderContainer>
        </InnerSearchContainerSmall>
      </SearchContainer>
      <Dropdown1 open={isOpen1} onToggle={handleToggle1}>
        <Summary>Консалтинг</Summary>
        {isOpen1 == true && (
          <PContainer1 ref={PcontR}>
            <P onClick={toServices2}>Карьерная консультация</P>
            <P onClick={toServices3}>Резюме под ключ</P>
            <P onClick={toServices4}>Пакетное сопровождение «Хочу оффер»</P>
            <P onClick={toServices5}>Сопровождение испытательного срока</P>
            <P onClick={toServices1}>Выговориться</P>
          </PContainer1>
        )}
      </Dropdown1>
      <Dropdown2 open={isOpen2} onToggle={handleToggle2}>
        <Summary>О нас</Summary>
        {isOpen2 == true && (
          <PContainer ref={contR}>
            <P onClick={toAbout}>О компании</P>
            <P onClick={toRatings}>Отзывы</P>
            <P onClick={toBlog}>Блог</P>
          </PContainer>
        )}
      </Dropdown2>
      <Container>
        <DivLink>
          <Link1 onClick={toServices6}>IT подбор</Link1>
          <Link onClick={toServices7}>Обучение</Link>
        </DivLink>
        <Link2 $img={require("./burger.png")} onClick={ShowSearch} />
        <Logo src={logo1} onClick={toMain} />
        <Div>
          <Burger $img={require("./Icon.png")} onClick={ShowSearchSmall} />
          <Link onClick={ShowSearch}>Поиск</Link>
          <Question href="https://t.me/ProhorovaConsult">
            Задать вопрос в TG
          </Question>
        </Div>
      </Container>
    </HeaderContainer>
  );
};

export default Header;
